import { BorderStyle } from '@email-editor/ui'
import Option from '../../components/Option'
import BorderRow from './BorderRow'

export default function SingleBorder(props: {
  width: number
  style: BorderStyle
  color: string
  updateWidth: (value: number) => void
  updateStyle: (value: BorderStyle) => void
  updateColor: (value: string) => void
}) {
  return (
    <Option>
      <BorderRow {...props} />
    </Option>
  )
}
